import Author from './author'

export default Author
